module.exports = __webpack_public_path__ + "5323f2a633eb70a0adfdaf32b59f0b50.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/poster.png
// module id = 608
// module chunks = 5